import { createFileRoute } from "@tanstack/react-router";
import { ServicePageTemplate } from "@/components/ServicePageTemplate";
import { serviceBySlug } from "@/data/services";
import { breadcrumbSchema, faqSchema, jsonLd, serviceSchema, absUrl } from "@/lib/seo";

const service = serviceBySlug["herrklippning"];

export const Route = createFileRoute("/herrklippning")({
  head: () => ({
    meta: [
      { title: service.seoTitle },
      { name: "description", content: service.metaDescription },
      { property: "og:title", content: service.seoTitle },
      { property: "og:description", content: service.metaDescription || service.excerpt },
      { property: "og:type", content: "website" },
      { property: "og:url", content: absUrl(service.url) },
    ],
    links: [{ rel: "canonical", href: absUrl(service.url) }],
    scripts: [
      jsonLd(serviceSchema(service)),
      jsonLd(faqSchema(service.faq)),
      jsonLd(breadcrumbSchema([{ name: "Hem", url: "/" }, { name: "Tjänster", url: "/herrklippning" }, { name: service.name, url: service.url }])),
    ],
  }),
  component: () => <ServicePageTemplate service={service} />,
});
